import { call, put, select, takeLatest } from 'redux-saga/effects'

import { IHateoasLink } from '@store'
import { selectAuthToken } from '@store/auth/selectors'
import { fetchCampaign, fetchCampaignSuccess, selectCampaignLink } from '@store/campaigns'
import { attachNotes, attachNotesFailure, attachNotesSuccess } from '@store/discoveryRuns/actions'
import {
  ATTACH_NOTES_REL,
  buildNotesFormData,
  extractVerbatimErrorMessage,
  isAlreadyAttachedError,
  multipartRequest,
} from '@store/discoveryRuns/api'
import { toast } from '@tribegroup'

export function* attachNotesSaga(action: ReturnType<typeof attachNotes>) {
  const { campaignId, file, notes } = action.payload
  try {
    const token: string = yield select(selectAuthToken)
    // attach_notes is a rel on the BRIEF's own top-level `links` (not nested
    // inside the `sourcing` block).
    const link: IHateoasLink | undefined = yield select(
      selectCampaignLink,
      campaignId,
      ATTACH_NOTES_REL,
    )
    if (!link) {
      // Surface the dead-end to the user, not just redux state (review fix).
      yield put(attachNotesFailure("Notes can't be attached right now."))
      yield call(toast, "Notes can't be attached right now.")
      return
    }

    const formData = buildNotesFormData(file, notes)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response: any = yield call(multipartRequest, link.method, link.href, formData, token)
    yield put(fetchCampaignSuccess(response))
    yield put(attachNotesSuccess())
  } catch (e: any) {
    const message = extractVerbatimErrorMessage(e)
    if (isAlreadyAttachedError(e)) {
      // BE state is AHEAD of the FE (notes already attached server-side) —
      // effective success: refetch the campaign so note_attached syncs,
      // clear the in-flight flag, keep the verbatim toast (review fix).
      yield put(fetchCampaign(campaignId))
      yield put(attachNotesSuccess())
      yield call(toast, message)
      return
    }
    yield put(attachNotesFailure(message))
    yield call(toast, message)
  }
}

export default function* watchAttachNotes() {
  yield takeLatest(attachNotes.type, attachNotesSaga)
}
